module.exports = __webpack_public_path__ + "img/Portrait_Smartphone.f304741b.jpg";